// src/theme/defaults.js
//
// THE portal default theme — the only place it is written down (spec
// 20260930-caro-editorial-theme, FR-10, plan §7.11, AC-14).
//
// Every default follows this constant: the cookie default (utils/cookie-utils.js), the
// ThemeContext initial state, the unknown-key fallback in create-theme.js, "Reset all" (which
// removes the cookie and so lands here) and the index.html preload script (Vite replaces
// %CARO_DEFAULT_PORTAL_THEME% with this value, see defaultThemeHtml.js).
//
// Plain JS without imports, so vite.config.js can read it too.
// Switched from 'plum' to 'editorial' on 2026-09-30 at the owner's request (T117-T121). A stored
// 'plum' could not be told apart from "never chose", so migratePortalThemeDefault()
// (utils/cookie-utils.js) moves plum and cookie-less users to Editorial ONCE; whoever picks Plum
// again afterwards keeps it.
export const DEFAULT_PORTAL_THEME = 'editorial';
